var map = {
	"./almoco.webp": 5494,
	"./banners/2026/fixos/catupiry.webp": 7651,
	"./banners/2026/fixos/getnet.webp": 2753,
	"./banners/2026/fixos/mondelez.mp4": 2689,
	"./banners/2026/fixos/nita.webp": 8292,
	"./banners/2026/fixos/seara.webp": 8188,
	"./banners/2026/rotativos/bandnews.gif": 9347,
	"./banners/2026/rotativos/food-to-save.png": 9264,
	"./banners/2026/rotativos/ip-embalagens.jpg": 9091,
	"./banners/2026/rotativos/sindipan.png": 2112,
	"./bg-outras-edicoes.webp": 6672,
	"./bg_baker.png": 9936,
	"./bg_contest.png": 2871,
	"./bg_padocaria.png": 9757,
	"./bg_step.png": 8769,
	"./bg_voteform.png": 5361,
	"./categorias/mapa-regioes-padocaria-bh-with-bg.webp": 2017,
	"./categorias/mapa-regioes-padocaria-bh.webp": 8076,
	"./categorias/melhor-atendimento.webp": 4450,
	"./categorias/melhor-bolo.webp": 2766,
	"./categorias/melhor-broinha.webp": 8965,
	"./categorias/melhor-cafe-com-nutella.webp": 6249,
	"./categorias/melhor-cafe.webp": 8733,
	"./categorias/melhor-doce.webp": 2937,
	"./categorias/melhor-fatiador-de-frios.webp": 1582,
	"./categorias/melhor-folhado.webp": 7175,
	"./categorias/melhor-frango-assado.webp": 5705,
	"./categorias/melhor-padaria-bh-coracao.webp": 8688,
	"./categorias/melhor-padaria-bh-estado.webp": 7662,
	"./categorias/melhor-padaria-bh-trofeu.webp": 5853,
	"./categorias/melhor-padaria-guarulhos.webp": 1429,
	"./categorias/melhor-padaria-sp-coracao.webp": 5169,
	"./categorias/melhor-padaria-sp-estado.webp": 7189,
	"./categorias/melhor-padaria-sp-trofeu.webp": 7814,
	"./categorias/melhor-padaria-sustentavel.webp": 6223,
	"./categorias/melhor-padaria.webp": 4956,
	"./categorias/melhor-pao-de-queijo.webp": 4200,
	"./categorias/melhor-pao-fermentacao-natural.webp": 892,
	"./categorias/melhor-pao-na-chapa-catupiry.webp": 3292,
	"./categorias/melhor-pao-na-chapa.webp": 1114,
	"./categorias/melhor-paozinho.webp": 6076,
	"./categorias/melhor-pizza.webp": 2478,
	"./categorias/melhor-sanduba.webp": 3128,
	"./categorias/melhor-sonho.webp": 5417,
	"./categorias/melhor-time-de-chapeiros-v1.webp": 5024,
	"./categorias/melhor-time-de-chapeiros-v2.webp": 3677,
	"./categorias/primeiro-lugar.webp": 425,
	"./categorias/trofeu-padocaria.webp": 9888,
	"./icon_brasil.png": 1494,
	"./icon_calendar.png": 2695,
	"./icon_chat.png": 9847,
	"./icon_check.png": 7309,
	"./icon_close.png": 7689,
	"./icon_face.png": 2386,
	"./icon_facebook.png": 4049,
	"./icon_first.png": 5603,
	"./icon_google.png": 9032,
	"./icon_instagram.png": 5373,
	"./icon_linkedin.png": 5443,
	"./icon_location.png": 9912,
	"./icon_search.png": 3325,
	"./icon_sp.png": 504,
	"./icon_sp_big.png": 103,
	"./icon_sp_love.png": 2709,
	"./icon_step_1.png": 8111,
	"./icon_step_2.png": 3460,
	"./icon_step_award.png": 1697,
	"./icon_trigo.png": 5712,
	"./icons/arrow-back.webp": 2969,
	"./icons/arrow-down.webp": 4850,
	"./image-folhado.jpg": 982,
	"./image_cafezinho.png": 5724,
	"./image_chapeiro.png": 8376,
	"./image_doce.jpg": 9722,
	"./image_doce.png": 3694,
	"./image_fermentacao_natural.jpg": 6596,
	"./image_flip.png": 8620,
	"./image_frios.png": 1558,
	"./image_padaria.png": 7649,
	"./image_padoca.png": 5275,
	"./image_padocaria.png": 9879,
	"./image_paonachapa.png": 2319,
	"./image_paozinho.png": 9793,
	"./image_pizza.png": 2611,
	"./image_sanduba.png": 7021,
	"./logo2.png": 8886,
	"./logo_google.svg": 5300,
	"./logo_olivas_digital.png": 3602,
	"./logo_padocaria.png": 5697,
	"./logo_padocaria_small.png": 5701,
	"./logos/logo-padocaria-26.webp": 4411,
	"./logos/logo-padocaria-bh-26.webp": 6808,
	"./logos/logo-padocaria-sp-26.webp": 5727,
	"./marker-icon.png": 3931,
	"./premiacoes/bh/2026/bonissima-lourdes.webp": 3886,
	"./premiacoes/bh/2026/ceu-azul.webp": 5580,
	"./premiacoes/bh/2026/coisa-de-vo.webp": 7361,
	"./premiacoes/bh/2026/colombina.webp": 1310,
	"./premiacoes/bh/2026/forno-doro.webp": 7177,
	"./premiacoes/bh/2026/galeria-dos-paes.webp": 9450,
	"./premiacoes/bh/2026/geracao-do-pao.webp": 3629,
	"./premiacoes/bh/2026/manteiga-caramelo.webp": 735,
	"./premiacoes/bh/2026/mata-das-borboletas.webp": 1746,
	"./premiacoes/bh/2026/padre-eustaquio.webp": 111,
	"./premiacoes/bh/2026/patricia-drumond.webp": 661,
	"./premiacoes/bh/2026/pedro-padeiro.webp": 8043,
	"./premiacoes/bh/2026/ping-pao.webp": 7137,
	"./premiacoes/bh/2026/trigo-pinho.webp": 9612,
	"./premiacoes/bh/2026/vianney.webp": 6606,
	"./premiacoes/sp/2021/ceci-cafe.webp": 5552,
	"./premiacoes/sp/2021/ceci-chapeiros.webp": 5671,
	"./premiacoes/sp/2021/ceci-frios.webp": 7846,
	"./premiacoes/sp/2021/cepam-doce.webp": 1642,
	"./premiacoes/sp/2021/cepam-pao.webp": 9985,
	"./premiacoes/sp/2021/cepam.webp": 5444,
	"./premiacoes/sp/2021/estado-luso-pao.webp": 3903,
	"./premiacoes/sp/2021/estado-luso.webp": 5782,
	"./premiacoes/sp/2021/fiorella.webp": 3940,
	"./premiacoes/sp/2021/galeria-dos-paes.webp": 956,
	"./premiacoes/sp/2021/merci.webp": 2906,
	"./premiacoes/sp/2022/big-pao.webp": 6644,
	"./premiacoes/sp/2022/ceci-cafe.webp": 4601,
	"./premiacoes/sp/2022/ceci-chapeiros.webp": 2524,
	"./premiacoes/sp/2022/ceci-doce.webp": 2653,
	"./premiacoes/sp/2022/ceci-frios.webp": 2353,
	"./premiacoes/sp/2022/ceci-pao.webp": 4188,
	"./premiacoes/sp/2022/ceci-sul.webp": 9952,
	"./premiacoes/sp/2022/ceci.webp": 4489,
	"./premiacoes/sp/2022/cepam.webp": 1845,
	"./premiacoes/sp/2022/estado-luso-pao.webp": 8486,
	"./premiacoes/sp/2022/galeria-dos-paes.webp": 9907,
	"./premiacoes/sp/2022/merci.webp": 3139,
	"./premiacoes/sp/2022/zn.webp": 177,
	"./premiacoes/sp/2023/bella-paulista.webp": 9466,
	"./premiacoes/sp/2023/big-pao-doce.webp": 9891,
	"./premiacoes/sp/2023/ceci-pao.webp": 6153,
	"./premiacoes/sp/2023/ceci-sul.webp": 4189,
	"./premiacoes/sp/2023/ceci.webp": 8092,
	"./premiacoes/sp/2023/cepam-chapeiros.webp": 5520,
	"./premiacoes/sp/2023/cepam.webp": 4074,
	"./premiacoes/sp/2023/estado-luso-pao.webp": 5733,
	"./premiacoes/sp/2023/estado-luso.webp": 7400,
	"./premiacoes/sp/2023/florestal-cafe.webp": 7714,
	"./premiacoes/sp/2023/merci.webp": 9236,
	"./premiacoes/sp/2023/palmeiras-frios.webp": 4192,
	"./premiacoes/sp/2023/vera-cruz-pizza.webp": 7070,
	"./premiacoes/sp/2024/academia-do-pao.webp": 725,
	"./premiacoes/sp/2024/arizona.webp": 469,
	"./premiacoes/sp/2024/big-pao.webp": 258,
	"./premiacoes/sp/2024/casa-napoles.webp": 1658,
	"./premiacoes/sp/2024/ceci.webp": 5231,
	"./premiacoes/sp/2024/cepam.webp": 2571,
	"./premiacoes/sp/2024/estado-luso-pao.webp": 2628,
	"./premiacoes/sp/2024/estado-luso.webp": 5889,
	"./premiacoes/sp/2024/forno-fecchio.webp": 5849,
	"./premiacoes/sp/2024/galeria-dos-paes.webp": 5749,
	"./premiacoes/sp/2024/merci.webp": 7754,
	"./premiacoes/sp/2024/pa-douro.webp": 8818,
	"./premiacoes/sp/2024/vera-cruz.webp": 9052,
	"./premiacoes/sp/2025/arizona.webp": 1606,
	"./premiacoes/sp/2025/bella-paulista.webp": 2960,
	"./premiacoes/sp/2025/big-pao.webp": 1033,
	"./premiacoes/sp/2025/ceci-sul.webp": 7839,
	"./premiacoes/sp/2025/ceci.webp": 9714,
	"./premiacoes/sp/2025/cepam.webp": 2064,
	"./premiacoes/sp/2025/chez-roberta.webp": 1460,
	"./premiacoes/sp/2025/estado-luso.webp": 2274,
	"./premiacoes/sp/2025/galeria-dos-paes.webp": 8832,
	"./premiacoes/sp/2025/merci.webp": 150,
	"./premiacoes/sp/2025/michelli.webp": 8785,
	"./premiacoes/sp/2025/munhoz.webp": 424,
	"./premiacoes/sp/2025/padoca-da-praca.webp": 6360,
	"./premiacoes/sp/2025/santa-micaela.webp": 6128,
	"./premiacoes/sp/2025/vera-cruz.webp": 7139,
	"./regua-logos/bh-2026/amipao.webp": 6792,
	"./regua-logos/bh-2026/belotour.webp": 1373,
	"./regua-logos/bh-2026/cdl-fm.webp": 8178,
	"./regua-logos/bh-2026/food-to-save.webp": 2479,
	"./regua-logos/bh-2026/fredizak.webp": 7829,
	"./regua-logos/bh-2026/getnet.webp": 3556,
	"./regua-logos/bh-2026/iel.webp": 8739,
	"./regua-logos/bh-2026/ip-embalagens.webp": 3870,
	"./regua-logos/bh-2026/krug.webp": 4154,
	"./regua-logos/bh-2026/prefeitura.webp": 9158,
	"./regua-logos/bh-2026/sebrae.webp": 4413,
	"./regua-logos/sp-2026/bandnews.webp": 2226,
	"./regua-logos/sp-2026/catupiry.webp": 4707,
	"./regua-logos/sp-2026/food-to-save.webp": 758,
	"./regua-logos/sp-2026/getnet.webp": 6353,
	"./regua-logos/sp-2026/ip-embalagens.webp": 6069,
	"./regua-logos/sp-2026/mondelez.webp": 2142,
	"./regua-logos/sp-2026/nita.webp": 1428,
	"./regua-logos/sp-2026/seara.webp": 2988,
	"./regua-logos/sp-2026/sindipan.webp": 38,
	"./vitrine-doces.webp": 1075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3233;